module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/021-cook-islands-22dfb8e95612611e55766fa01e4c41bd.svg";